var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.337,
    height: 16.2,
    viewBox: "0 0 47.337 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "teeth-group",
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-832.888 -118.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_16",
    "data-name": "Component 16",
    transform: "translate(832.888 118.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_71",
    "data-name": "Subtraction 71",
    d: "M38,16.055H7.89L0,9.62,2.411,0H38V16.054Z",
    transform: "translate(47.337 16.055) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_72",
    "data-name": "Subtraction 72",
    d: "M38,0H7.89L0,6.435l2.411,9.62H38V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M2.938,10.4l42.487.026L42.516.787H5.9Z",
    transform: "translate(-0.523 5.777)",
    fill: "#fec5c6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mask",
    id: "Union_48",
    "data-name": "Union 48",
    transform: "translate(-863 -2128)",
    fill: "#2a3033"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M865.415,2144.175l.037-.119h-.041l-2.411-9.62L870.89,2128h31.558l7.89,6.435-2.411,9.62h-.069l.044.145Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M 905.2001342773438 2142.19873046875 L 905.156494140625 2142.0556640625 L 906.36572265625 2142.0556640625 L 908.0884399414063 2135.18212890625 L 901.7349853515625 2130.00048828125 L 872.3412475585938 2130.00048828125 L 871.6017456054688 2130.00048828125 L 865.2490844726563 2135.18212890625 L 866.9718017578125 2142.0556640625 L 868.167236328125 2142.0556640625 L 868.1297607421875 2142.17626953125 L 905.2001342773438 2142.19873046875 M 907.901123046875 2144.200439453125 L 865.414794921875 2144.174560546875 L 865.4517211914063 2144.0556640625 L 865.4111938476563 2144.0556640625 L 863.0001220703125 2134.435546875 L 870.8895263671875 2128.00048828125 L 872.3412475585938 2128.00048828125 L 902.4471435546875 2128.00048828125 L 910.33740234375 2134.435546875 L 907.9263305664063 2144.0556640625 L 907.8569946289063 2144.0556640625 L 907.901123046875 2144.200439453125 Z",
    stroke: "none",
    fill: "#fff",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchView);
export default __webpack_public_path__ + "static/media/ArchView.93cc769272759aff0dbffc9f45ca984a.svg";
export { ForwardRef as ReactComponent };